import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";
export const GetAllSpeciality = createAsyncThunk(
  "practitioner/GetAllSpeciality",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("specilaityList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const SearchPractitioner = createAsyncThunk(
  "practitioner/SearchPractitioner",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post(
        "profiles/practnameSearch",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllPractitionerList = createAsyncThunk(
  "practitioner/GetAllPractitionerList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "profiles/practitionerList",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CreatePractitioner = createAsyncThunk(
  "practitioner/CreatePractitioner",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "profiles/practitionerCreate",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ImportPractitioner = createAsyncThunk(
  "practitioner/ImportPractitioner",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "profiles/practitionerImport",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetIndividualParctitioner = createAsyncThunk(
  "practitioner/GetIndividualParctitioner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`profiles/practitionerView/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const DeletePractitioner = createAsyncThunk(
  "practitioner/DeletePractitioner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`profiles/practitionerDel/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
